// extracted by mini-css-extract-plugin
export default {"body":"TransferModal_body__vR7xN","burnButton":"TransferModal_burnButton__0FgJu","destinationInput":"TransferModal_destinationInput__6jZfr"};